import config from '../config.json'

const auth = (resource, authType) => {

  if (!config.auth) return false

  const splittedTree = resource.split('.')

  let currentTree = config.auth

  for ( let i = 0; i < splittedTree.length; i++ ) {
    
     if ( i === splittedTree.length - 1 ) {

      if ( !currentTree[splittedTree[i]] ) return false

      if ( !currentTree[splittedTree[i]]['a'] ) return false

      if ( currentTree[splittedTree[i]]['a'].toLowerCase().includes(authType.toLowerCase())) return true 

      return false
    }

    if ( !currentTree[splittedTree[i]] ) return false

    currentTree = currentTree[splittedTree[i]]
 
  }
}

export default auth